<script setup lang="ts">
interface Props {
  title?: string;
  videoId: string;
  frameborder?: string;
  allow?: string;
  allowfullscreen?: boolean;
  width?: string;
  height?: string;
}

defineProps<Props>();
const isShow = ref(false);
</script>

<template>
  <div class="aspect-video w-full tablet:w-2/3 mx-auto" @click="isShow = true">
    <div
      class="flex items-center justify-center relative hover:brightness-90 cursor-pointer"
      v-if="!isShow"
    >
      <ImageEl
        class="w-full"
        :src="`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`"
        :alt="title"
        width="1280"
        height="720"
        size="100%"
        format="webp"
      />
      <Icon
        class="absolute bg-red-600 text-white rounded-lg"
        size="32"
        name="mdi:play"
      />
      <span
        class="absolute top-0 left-0 bg-black p-2 text-white bg-opacity-50"
        >{{ title }}</span
      >
    </div>
    <iframe
      v-if="isShow"
      :title="title"
      :src="`https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`"
      :frameborder="frameborder"
      :allow="allow"
      :allowfullscreen="allowfullscreen"
    ></iframe>
  </div>
</template>
